export const MAPS_KEY = 'AIzaSyAeQWFI32vEHDFh5i2pRfX8nRfnYqnjJ0Q';
export const MAPS_STORAGE_IDENTIFIER = 'config.google.maps';